var _a;
export var ReportType;
(function (ReportType) {
    ReportType["Unspecified"] = "unspecified";
    ReportType["ProgramReview"] = "programReview";
    ReportType["Spotlight"] = "spotlight";
    ReportType["WeeklySnapshot"] = "weeklySnapshot";
    ReportType["CumulativeSitePixelData"] = "cumulativeSitePixelData";
    ReportType["CumulativeIntentFeedTopics"] = "cumulativeIntentFeedTopics";
    ReportType["CumulativeIntentFeedBRS"] = "cumulativeIntentFeedBrs";
    ReportType["CumulativeAdSolutions"] = "cumulativeAdSolutions";
    ReportType["DisplayCumulativeAdSolutions"] = "displayCumulativeAdSolutions";
    ReportType["DisplayCumulativeIntentFeedBRS"] = "displayCumulativeIntentFeedBRS";
    ReportType["Moat"] = "moat";
    ReportType["DisplayAccountLevel"] = "displayAccountLevel";
    ReportType["InnovidDisplayAccountLevel"] = "innovidDisplayAccountLevel";
})(ReportType || (ReportType = {}));
export var ReportTypeLabel = (_a = {},
    _a[ReportType.Unspecified] = 'Unspecified',
    _a[ReportType.Spotlight] = 'Account Spotlight',
    _a[ReportType.ProgramReview] = 'Program Review',
    _a[ReportType.WeeklySnapshot] = 'Weekly Snapshot',
    _a[ReportType.CumulativeAdSolutions] = 'Cumulative Ad Solutions',
    _a[ReportType.CumulativeIntentFeedBRS] = 'Cumulative Intent Feed BRS',
    _a[ReportType.CumulativeIntentFeedTopics] = 'Cumulative Intent Feed Topics',
    _a[ReportType.CumulativeSitePixelData] = 'Cumulative Site Pixel Data',
    _a[ReportType.DisplayCumulativeAdSolutions] = 'Display Cumulative Ad Solutions',
    _a[ReportType.DisplayCumulativeIntentFeedBRS] = 'Display Cumulative Intent Feed - BRS WoW',
    _a[ReportType.Moat] = 'MOAT',
    _a[ReportType.DisplayAccountLevel] = 'Account-Level Display Report',
    _a[ReportType.InnovidDisplayAccountLevel] = 'Innovid Account-Level Display Report',
    _a);
//# sourceMappingURL=ReportType.js.map